import * as i0 from '@angular/core';
import { inject, EventEmitter, Injectable, Output, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpClientModule, HTTP_INTERCEPTORS, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, of, timer, Subject, BehaviorSubject } from 'rxjs';
import { tap, mapTo, catchError, takeWhile, filter, map, switchMap, take } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import * as i2 from '@angular/router';
import * as CryptoJS from 'crypto-js';
import * as i1 from 'ngx-mqtt';
import { MqttConnectionState, MqttModule } from 'ngx-mqtt';
export * from 'ngx-mqtt';
import * as signalR from '@microsoft/signalr';
export * from '@microsoft/signalr';
import { webSocket } from 'rxjs/webSocket';
import * as AWS from 'aws-sdk';

/**
 * The class includes some methods used to properly render app graphical behaviors
 */
class GraphicUtils {
    /**
     * The method is used to calculate browser window's width from document object,
     * and returns whether width is greater or lower than the breakpoint threshold
     */
    static isScreenWidthGreater(breakpoint) {
        const w = document.documentElement.clientWidth;
        return w < breakpoint;
    }
}

/**
 * This class describes the correct output of a login request, that is access_token, refresh_token and other params
 */
class JwtDTO$1 {
}

/**
 * This enum is used to check the type of the server response
 */
var EXIT_CODE;
(function (EXIT_CODE) {
    /**
     * Ok Server response code
     */
    EXIT_CODE["OK"] = "OK";
    /**
     * Security Error Server response code
     */
    EXIT_CODE["SE"] = "SE";
    /**
     * Input Validation Error Server response code
     */
    EXIT_CODE["IVE"] = "IVE";
    /**
     * Output Validation Error Server response code
     */
    EXIT_CODE["OVE"] = "OVE";
    /**
     * Execution Error Server response code
     */
    EXIT_CODE["EE"] = "EE";
})(EXIT_CODE || (EXIT_CODE = {}));

/**
 * Http Error Manager Utility class
 */
class HttpErrorManager {
    /**
     * This method receives a response and analizes the error generated by BE,
     * specifying what is the type and the message of error.
     * @param response: server response
     * @returns error message
     */
    static serverErrorHandler(response) {
        const result = response;
        if (result.ec === EXIT_CODE.EE.toString()) {
            if (result.ee.serverError) {
                return 'GENERIC_ERROR';
            }
            // This is an execution error
            return result.ee.en + (!!result.ee.em ? (': ' + result.ee.em) : '');
        }
        else if (result.ec === EXIT_CODE.SE.toString()) {
            // This is a security error
            return result.se.em;
        }
        else if (result.ec === EXIT_CODE.IVE.toString()) {
            // This is an input validation error
            return result.ive.vm.join(' - ');
        }
        else if (result.ec === EXIT_CODE.OVE.toString()) {
            // This is an output validation error
            return result.ove.vm.join(' - ');
        }
    }
    /**
     * This method receives an HttpErrorResponse and handles the error
     * @param error: Http Error
     * @returns error message and details
     */
    static httpErrorHandler(error) {
        if (error.status === 500) {
            // Managing a 500 http errors, that is an applicative error
            if (!!error.error['error'] && !!error.error['details']) {
                return `${error.error['details']} (error id: [${error.error['error']}])`;
            }
            else {
                return 'GENERIC_ERROR';
            }
        }
        else if (error.status === 503) {
            return 'GENERIC_ERROR';
        }
        else if (error.status.toString().startsWith('5')) {
            // Managing all 5** http errors
            // The object has the following fields:
            //  - name: Error name
            //  - message: Error message
            //  - status: Http status code
            //  - statusText: Http status description
            return `${error.name}: ${error.status} ${error.statusText}`;
        }
        else if (error.status === 0) {
            // Problema NAME_NOT_RESOLVED o comunque problema di comunicazione, non ho uno stato di errore
            console.log(error.name + ': ' + error.message);
            return error.name + ': ' + error.message;
        }
        else if (!!error.error['error'] && !!error.error['error_description']) {
            return `${error.error['error_description']} (error id: [${error.error['error']}])`;
        }
        else if (!!error.error['error'] && !!error.error['details']) {
            return `${error.error['details']} (error id: [${error.error['error']}])`;
        }
        return JSON.stringify(error.error);
    }
}

class LoginResponse {
    constructor(flag, er = '') {
        this.error = er;
        this.ok = flag;
    }
}

/**
 * BaseCB Class for AIknow CommunicatorBean concept (common for all BEs)
 */
class BaseCB {
}

/**
 * BaseCubaServiceCB Class for AIknow CommunicatorBean concept
 */
class BaseCubaServiceCB extends BaseCB {
    constructor(serviceName, opeName) {
        super();
        this.opeName = opeName;
        this.serviceName = serviceName;
    }
}

class I {
}
class O {
}
class GetOPESIInfoCB extends BaseCubaServiceCB {
    constructor() {
        super('RegistryService', 'getOPESIInfo');
        this.i = new I();
        this.o = new O();
    }
}

/**
 * CubaRest service class
 * This service is used to manage HTTP connections to a CUBA Backend.
 */
class CubaRestService {
    /**
     * This is the class constructor, which instantiates a private object
     */
    constructor() {
        /**
         * This private property is used to store the login status (Logged / Not Logged)
         */
        this.isUserLogged = false;
        /**
         * This property is true when the refresh_token is expired
         */
        this.refreshedExpired = false;
        /**
         * the HttpClient object used to perform http requests and handle their responses
         */
        this.http = inject(HttpClient);
        /**
         * This EventEmitter is triggered when the token is correctly received from server and stored
         */
        this.tokenCaught = new EventEmitter();
        this.Token = new JwtDTO$1();
    }
    /**
     * This method is called to check whether the user is correctly logged or not
     */
    isUserLoggedIn() {
        this.isUserLogged = (!!this.Token.access_token) ||
            (localStorage.getItem('access_token') !== undefined && localStorage.getItem('access_token') !== null);
        return this.isUserLogged;
    }
    execLoginOpe(url, cb) {
        this.feLoginUrlAPI = url + cb.serviceName + '/' + cb.opeName;
        return new Observable((observer) => {
            let cbInput = JSON.parse('{}');
            if (cb !== null) {
                cbInput = JSON.parse(JSON.stringify(cb.i));
            }
            this.http.post(this.feLoginUrlAPI, cbInput).subscribe(tokens => {
                if (tokens !== undefined) {
                    // activated REMEMBER ME, MUST STORE TOKEN in LOCAL STORAGE
                    this.rememberMeFlag = true;
                    localStorage.setItem('access_token', tokens.access_token);
                    localStorage.setItem('refresh_token', tokens.refresh_token);
                    cb.o = JSON.parse(JSON.stringify(tokens));
                    observer.next(new LoginResponse(true));
                }
            }, (error) => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * This method is used to execute a http post request in order to gain the access and receive a token
     * @param user: the username
     * @param pswd: the password
     * @param urlAPI: the api used to do login
     * @param rememberMe: flag used to activate the "Remember me" function
     */
    login(user, pswd, urlAPI, rememberMe) {
        this.cubaLoginUrlAPI = urlAPI;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
                Authorization: 'Basic Y2xpZW50OnNlY3JldA=='
            })
        };
        return this.http.post(this.cubaLoginUrlAPI, 'grant_type=password&username=' + user + '&password=' + pswd, httpOptions)
            .pipe(tap(tokens => {
            if (tokens !== undefined) {
                if (rememberMe) {
                    // activated REMEMBER ME, MUST STORE TOKEN in LOCAL STORAGE
                    this.rememberMeFlag = true;
                    localStorage.setItem('access_token', tokens.access_token);
                    localStorage.setItem('refresh_token', tokens.refresh_token);
                }
                else {
                    // deactivated REMEMBER ME, STORE TOKEN ONLY in JWT OBJECT
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    this.rememberMeFlag = false;
                    this.storeTokens(tokens, false);
                }
            }
        }), mapTo(new LoginResponse(true)), catchError(error => {
            return of(new LoginResponse(false, error));
        }));
    }
    /**
     * This method is called when a correct login is done, in order to store the received token and other login information
     * @param tokens login information
     * @param flag is used to check whether the token has been refreshed or not
     */
    storeTokens(tokens, flag) {
        this.Token.access_token = tokens.access_token;
        this.Token.refresh_token = tokens.refresh_token;
        this.Token.token_type = tokens.token_type;
        this.Token.expires_in = tokens.expires_in;
        this.Token.scope = tokens.scope;
        // il servizio non deve utilizzare le rotte, deve essere indipendente --> uso un emettitore di eventi
        if (!flag) {
            this.tokenCaught.emit(tokens.access_token);
        }
    }
    /**
     * This method deletes an access_token saved in internal memory
     */
    clearTokens() {
        // CLEAR TOKEN IN JWT OBJECT
        this.Token.access_token = undefined;
        this.Token.refresh_token = undefined;
        this.Token.token_type = undefined;
        this.Token.expires_in = 0;
        this.Token.scope = undefined;
        this.isUserLogged = false;
        // CLEAR TOKEN IN Local Storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        return true;
    }
    /**
     * This method is called to obtain the string containing the access token
     */
    getToken() {
        const tokenFromStorage = localStorage.getItem('access_token');
        if (!!tokenFromStorage) {
            return tokenFromStorage;
        }
        else {
            return this.Token.access_token;
        }
    }
    /**
     * This method is called to obtain the string containing the refresh token
     */
    getRefreshToken() {
        const tokenRefFromStorage = localStorage.getItem('refresh_token');
        if (!!tokenRefFromStorage) {
            this.rememberMeFlag = true;
            return tokenRefFromStorage;
        }
        else {
            return this.Token.refresh_token;
        }
    }
    /**
     * This method is used to set an AUTH URL to perform refresh token operations
     * @param url the AUTH url
     * @param cubaFlag if true, the cuba login API is used, otherwise a custom service login ope is used
     */
    setAuthUrl(url, cubaFlag = true) {
        if (cubaFlag) {
            this.cubaLoginUrlAPI = url;
        }
        else {
            this.feLoginUrlAPI = url;
        }
    }
    setServiceLoginAuthUrl(url) {
        this.feLoginUrlAPI = url;
    }
    setCubaLoginAuthUrl(url) {
        this.cubaLoginUrlAPI = url;
    }
    /**
     * This method is used to execute a http post request in order to execute a refresh-token operation
     * and receive another valid token
     */
    refreshToken() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
                Authorization: 'Basic Y2xpZW50OnNlY3JldA=='
            })
        };
        return this.http.post(this.cubaLoginUrlAPI, 'grant_type=refresh_token&refresh_token=' + this.getRefreshToken(), httpOptions)
            .pipe(tap((tokens) => {
            const tokenRefFromStorage = localStorage.getItem('access_token');
            if (!!tokenRefFromStorage) {
                localStorage.setItem('access_token', tokens.access_token);
                localStorage.setItem('refresh_token', tokens.refresh_token);
                this.rememberMeFlag = true;
            }
            else {
                this.rememberMeFlag = false;
                this.Token.access_token = tokens.access_token;
                this.storeTokens(tokens, true);
            }
        }));
    }
    /**
     * This method is used to set the value for the Accept-Language header
     * @param locale the value of the language
     */
    setLanguage(locale) {
        this.language = locale;
    }
    /**
     * This method is used to get the value for the Accept-Language header
     */
    getLanguage() {
        return this.language;
    }
    /**
     * The method performs the logout from app and calls the clearTokens method
     */
    doLogout() {
        return this.clearTokens();
    }
    // SERVICES HANDLER
    // a single method that receives the name of the service and the respective cb
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside the cb if any. If there's a particular error, the message error is generated and passed
     * @param url the API url of the BE
     * @param cb the cb object
     */
    execOPE(url, cb) {
        return new Observable((observer) => {
            let cbInput = JSON.parse('{}');
            if (cb !== null) {
                cbInput = JSON.parse(JSON.stringify(cb.i));
            }
            this.http.post(url + cb.serviceName + '/' + cb.opeName, {
                cb: {
                    i: cbInput
                }
            }).subscribe((resp) => {
                let errorMessage = '';
                // IF OK
                if (resp['r']['ec'] === EXIT_CODE['OK']) {
                    cb.o = JSON.parse(JSON.stringify(resp['o']));
                    observer.next(true);
                }
                else {
                    errorMessage = HttpErrorManager.serverErrorHandler(resp['r']);
                    observer.error(errorMessage);
                }
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside the cb if any just like execOPE, but this method has to be used with ASYNC SI OPE.
     * Every 5 seconds the progress of the OPE is being checked, until its termination.
     * If there's a particular error, the message error is generated and passed
     * @param url the API url of the BE
     * @param cb the cb object
     */
    execOpeAsyncSI(url, cb) {
        let getOPESIInfosSubscription;
        return new Observable(subscriber => {
            this.execOPE(url, cb).subscribe({
                next: () => {
                    if (cb.o.info.running) {
                        // THIS IS AN ASYNC METHOD, SO WE MUST CONTINUE POLLING THE SERVICE STATUS IN ORDER TO OBTAIN INFOS
                        getOPESIInfosSubscription = this.checkOpeAsyncSI(url, cb.o.info.opeId).subscribe({
                            next: value => subscriber.next(value),
                            error: err => subscriber.error(err),
                            complete: () => subscriber.complete()
                        });
                    }
                    else {
                        // The OPE has already finished, exit
                        if (cb.r.ec === EXIT_CODE.OK) {
                            subscriber.next(cb.o.info);
                            subscriber.complete();
                        }
                        else {
                            const errorMessage = HttpErrorManager.serverErrorHandler(cb.r);
                            subscriber.error(errorMessage);
                        }
                        subscriber.next(cb.o.info);
                        subscriber.complete();
                    }
                },
                error: err => {
                    subscriber.error(err);
                }
            });
            return {
                unsubscribe() {
                    getOPESIInfosSubscription.unsubscribe();
                    console.log("unsubscribed checkOpeAsyncSI");
                }
            };
        });
    }
    /**
     * The method is called to check for a particular Single Instance Async OPE status.
     * @param url the API url of the BE
     * @param opeId the id of the OPE
     */
    checkOpeAsyncSI(url, opeId) {
        return new Observable((observer) => {
            let isRunningService = true;
            const cb = new GetOPESIInfoCB();
            // RETRIEVING OPE id from CB output
            cb.i.opeId = opeId;
            let timerSubscription = timer(0, 5000).pipe(takeWhile(() => isRunningService))
                .subscribe(() => {
                this.execOPE(url, cb).subscribe(() => {
                    const info = cb.o.info;
                    if (!info.running) {
                        // OPE IS NOT RUNNING
                        console.log('Service [' + opeId + '] is NOT running');
                        // EMIT OPE SI INFO AND COMPLETE
                        if (info.cb.r.ec === EXIT_CODE.OK) {
                            observer.next(info);
                            observer.complete();
                        }
                        else {
                            const errorMessage = HttpErrorManager.serverErrorHandler(info.cb.r);
                            observer.error(errorMessage);
                        }
                        // EXIT WHILE LOOP
                        isRunningService = false;
                    }
                    else {
                        // OPE IS RUNNING
                        console.log('Service [' + opeId + '] IS running');
                        // EMIT OPE SI INFO
                        observer.next(cb.o.info);
                    }
                }, error => {
                    // OPE GetOPESIInfo ENDED WITH ERROR
                    console.log('Service [' + opeId + '] ended with ERROR');
                    // SET OUTCOME MESSAGE
                    observer.error(error);
                    // EXIT WHILE LOOP
                    isRunningService = false;
                });
            });
            return {
                unsubscribe() {
                    timerSubscription.unsubscribe();
                    console.log("unsubscribed timer");
                }
            };
        });
    }
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside of the cb if any. If there's a particular error, the message error is generated and passed
     * @param url the API url of the mock BE
     * @param cb the cb object
     */
    execMockOPE(url, cb) {
        return new Observable((observer) => {
            let cbInput = JSON.parse('{}');
            if (cb !== null) {
                cbInput = JSON.parse(JSON.stringify(cb.i));
            }
            this.http.post(url, {
                cb: {
                    i: cbInput
                }
            }).subscribe((resp) => {
                let errorMessage = '';
                // IF OK
                if (resp['r']['ec'] === EXIT_CODE['OK']) {
                    cb.o = JSON.parse(JSON.stringify(resp['o']));
                    observer.next(true);
                }
                else {
                    errorMessage = HttpErrorManager.serverErrorHandler(resp['r']);
                    observer.error(errorMessage);
                }
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * This method enables to get the list of the entities present in the DB
     * @param url: the CUBA URL to handle entities
     * @param cb: the cb object
     */
    getEntity(url, cb) {
        return new Observable((observer) => {
            this.http.get(url + cb.composeQueryString(), { observe: 'response' }).subscribe((resp) => {
                cb.o = JSON.parse(JSON.stringify(resp.body));
                cb.xTotalCount = +resp.headers.get('X-Total-Count');
                observer.next(true);
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * This method enables to delete a particular entity present in the DB
     * @param url: the CUBA URL to handle entities
     * @param cb: the cb object
     */
    deleteEntity(url, cb) {
        return new Observable((observer) => {
            this.http.delete(url + cb.composeQueryString() + '/' + cb.i.id, {}).subscribe(resp => {
                cb.o = JSON.parse(JSON.stringify(resp));
                observer.next(true);
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * This method enables to add a particular entity in the DB
     * @param url the CUBA url to handle entities
     * @param cb: the cb object
     */
    addEntity(url, cb) {
        return new Observable((observer) => {
            this.http.post(url + cb.composeQueryString(), JSON.stringify(cb.i)).subscribe(resp => {
                cb.o = JSON.parse(JSON.stringify(resp));
                observer.next(true);
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     *
     * This method enables to modify a particular entity in the DB
     * @param url the CUBA url to handle entities
     * @param cb: the cb object
     */
    updateEntity(url, cb) {
        return new Observable((observer) => {
            this.http.put(url + cb.composeQueryString() + '/' + cb.i.id, JSON.stringify(cb.i)).subscribe(resp => {
                cb.o = JSON.parse(JSON.stringify(resp));
                observer.next(true);
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
}
CubaRestService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CubaRestService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; }, propDecorators: { tokenCaught: [{
                type: Output
            }] } });

/**
 * Library EventData
 */
class EventData {
    /**
     * EventData constructor
     * @param name the name of the event data
     * @param value the event payload
     */
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}

/**
 * EventData names available cross-applications
 */
class EventBusContstants {
}
/**
 * The event emits a force logout command
 */
EventBusContstants.FORCE_LOGOUT = 'forceLogout';
/**
 * The event emits a SignalR Connected status
 */
EventBusContstants.SIGNALR_STATUS_CONNECTED = 'signalRStatusConnected';

/**
 * EventBus Service Class.
 * This service manages an event bus through which every application component and service can emit and receive events
 */
class EventBusService {
    constructor() {
        /**
         * Event Subject,
         * A Subject is a special type of Observable that allows values to be
         * multicasted to many Observers. Subjects are like EventEmitters.
         *
         * Every Subject is an Observable and an Observer. You can subscribe to a
         * Subject, and you can call next to feed values as well as error and complete.
         */
        this.subject$ = new Subject();
    }
    /**
     * Event emission method
     * @param event the event to emit
     */
    emit(event) {
        this.subject$.next(event);
    }
    /**
     * Event subscription method
     * @param eventName the name of the event to be subscribed
     * @param action the callback action
     */
    on(eventName, action) {
        return this.subject$.pipe(filter((e) => e.name === eventName), map((e) => e.value)).subscribe(action);
    }
}
EventBusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: EventBusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EventBusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: EventBusService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: EventBusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * This class is used as an http interceptor: it catches all the exiting http requests and adds a specific header.
 * It's also used to handle a "token expired" case
 */
class TokenInceptor {
    /**
     * Class constructor
     * @param auth the AuthService object used to perform authentication operations
     * @param router the Router object used to redirect the displayed component (mainly in case of forced logout)
     * @param eventBus the EventBus service
     */
    constructor(auth, router, eventBus) {
        this.auth = auth;
        this.router = router;
        this.eventBus = eventBus;
        /**
         * This variable is used to set trace of a refreshing of a Jwt.
         * If true, no more refresh requests should be forwarded to the server
         */
        this.isRefreshing = false;
        /**
         * Variable used to handle token
         */
        this.refreshTokenSubject = new BehaviorSubject(null);
    }
    /**
     * Method inherited from HttpInterceptor that catches all requests and filters the 401 responses
     * @param request the intercepted request
     * @param next the handler
     */
    intercept(request, next) {
        request = this.addToken(request, this.auth.getToken());
        return next.handle(request).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 400) && this.auth.getToken()) {
                return this.handle401Error(request, next, error);
            }
            else if (error instanceof HttpErrorResponse && (error.status === 409)) {
                // Error is CONFLICT - return full error to FE
                return new Observable((observer) => {
                    observer.error(error.error);
                });
            }
            else {
                return new Observable((observer) => {
                    observer.error(HttpErrorManager.httpErrorHandler(error));
                });
            }
        }));
    }
    /**
     * This method adds the token in the request header
     * @param request Http Request caught
     * @param token Jwt
     */
    addToken(request, token) {
        if (request.url !== this.auth.cubaLoginUrlAPI && request.url !== this.auth.feLoginUrlAPI) {
            if (token === undefined) {
                return request;
            }
            console.log('adding to ' + request.url + '...');
            if (this.auth.getLanguage() !== undefined) {
                // HANDLE ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'Accept-Language': this.auth.getLanguage()
                    }
                });
            }
            else {
                // NO ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                });
            }
        }
        else if (request.url === this.auth.cubaLoginUrlAPI) {
            // IN CASE OF LOGINS MADE BY THE /rest/v2/oauth/token API
            if (this.auth.getLanguage() !== undefined) {
                // HANDLE ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        'Accept-Language': this.auth.getLanguage()
                    }
                });
            }
            else {
                // NO ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json'
                    }
                });
            }
        }
        else {
            // IN CASE OF LOGINS MADE BY THE /rest/oauth/feLogin API
            if (this.auth.getLanguage() !== undefined) {
                // HANDLE ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'Accept-Language': this.auth.getLanguage()
                    }
                });
            }
            else {
                // NO ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                });
            }
        }
    }
    /**
     * Method used to handle a token refresh. It must allow only one refresh request, and block the others until a new token is obtained
     * @param request: The http request
     * @param next: the Http handler
     * @param error: the error 400 or 401 received from a previous request which started the refresh process
     */
    handle401Error(request, next, error) {
        if (!this.isRefreshing) {
            if (error.status === 401) {
                console.log('askin\' for refreshedToken...');
                this.isRefreshing = true;
                this.refreshTokenSubject.next(null);
                return this.auth.refreshToken().pipe(switchMap((token) => {
                    console.log(token);
                    this.isRefreshing = false;
                    console.log('new token added to old httpRequest...');
                    this.refreshTokenSubject.next(token.access_token);
                    return next.handle(this.addToken(request, token.access_token));
                }));
            }
            else if (error.status === 400) {
                // if 400 call httpErrorHandler
                return new Observable((observer) => {
                    observer.error(HttpErrorManager.httpErrorHandler(error));
                });
            }
        }
        else {
            if (error.status === 400) {
                this.isRefreshing = false;
                this.auth.refreshedExpired = true;
                this.auth.clearTokens();
            }
            // può essere che qui ci vada una refreshToken quando il refresh è scaduto....
            // in questo caso devo prevedere una login di massa
            if (request.url === this.auth.cubaLoginUrlAPI || request.url === this.auth.feLoginUrlAPI) {
                // refreshToken gone bad.... do login!
                this.isRefreshing = false;
                this.auth.refreshedExpired = true;
                this.auth.clearTokens();
                this.eventBus.emit(new EventData(EventBusContstants.FORCE_LOGOUT, null));
                return new Observable((observer) => {
                    observer.error('Invalid refresh_token, must do new login');
                });
            }
            else {
                // 401 response not for bad RefreshToken
                console.log('token already requested... please be patient...');
                return this.refreshTokenSubject.pipe(filter(token => token != null), take(1), switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt));
                }));
            }
        }
    }
}
TokenInceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: TokenInceptor, deps: [{ token: CubaRestService }, { token: i2.Router }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Injectable });
TokenInceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: TokenInceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: TokenInceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CubaRestService }, { type: i2.Router }, { type: EventBusService }]; } });

class CubaRestModule {
}
CubaRestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CubaRestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: CubaRestModule, imports: [BrowserModule, FormsModule, HttpClientModule] });
CubaRestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestModule, providers: [HttpClient, {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInceptor,
            multi: true
        }], imports: [BrowserModule, FormsModule, HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: CubaRestModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [BrowserModule, FormsModule, HttpClientModule
                    ],
                    providers: [HttpClient, {
                            provide: HTTP_INTERCEPTORS,
                            useClass: TokenInceptor,
                            multi: true
                        }],
                    exports: []
                }]
        }] });

/**
 * BaseEntityCB Class for AIknow CommunicatorBean concept (for CUBA BEs only)
 */
class BaseEntityCB extends BaseCB {
    /**
     * Class constructor
     * @param entityName
     */
    constructor(entityName) {
        super();
        this.entityName = entityName;
    }
    /**
     * The method composes the query string using the parameters specified
     * (entityName, viewName, sortColumn, pageLimit, pageOffset)
     */
    composeQueryString() {
        let result = this.entityName;
        if (!!this.viewName || !!this.sortColumn || !!this.pageLimit || !!this.pageOffset || !!this.returnCount || !!this.filter) {
            // SOME OTHER PARAMETERS
            const parameterArray = new Array();
            if (!!this.viewName) {
                parameterArray.push(`view=${this.viewName}`);
            }
            if (!!this.sortColumn) {
                parameterArray.push(`sort=${this.sortColumn}`);
            }
            if (!!this.pageLimit) {
                parameterArray.push(`limit=${this.pageLimit}`);
            }
            if (!!this.pageOffset) {
                parameterArray.push(`offset=${this.pageOffset}`);
            }
            if (!!this.returnCount && this.returnCount) {
                parameterArray.push(`returnCount=true`);
            }
            if (!!this.filter) {
                result += '/search';
                const filterString = encodeURIComponent(JSON.stringify(this.filter));
                parameterArray.push(`filter=${filterString}`);
            }
            result += '?';
            result += parameterArray.reduce((a, b) => `${a}&${b}`);
        }
        return result;
    }
}

/**
 * BaseEntity Class for Cuba Entity APIs
 */
class BaseEntity {
}

/**
 * The class includes some useful methods to properly format data for a CUBA BE
 */
class CubaRestUtils {
    /**
     * The method converts a JS date in a string, in the form accepted by the CUBA backend
     * @param date the date to convert
     */
    static dateInCubaStringFormat(date) {
        const tempDate = new Date(date);
        return `${tempDate.getFullYear()}-${((tempDate.getMonth() + 1) < 10) ? '0' + (tempDate.getMonth() + 1) : (tempDate.getMonth() + 1)}-${(tempDate.getDate() < 10) ? '0' + tempDate.getDate() : tempDate.getDate()} 00:00:00.000`;
    }
    /**
     * The method converts date/time string in the format accepted by the CUBA backend
     * @param date the date to convert
     */
    static dateTimeInCubaStringFormat(date) {
        const tempDate = new Date(date);
        return `${tempDate.getFullYear()}-${((tempDate.getMonth() + 1) < 10) ? '0' + (tempDate.getMonth() + 1) : (tempDate.getMonth() + 1)}-${(tempDate.getDate() < 10) ? '0' + tempDate.getDate() : tempDate.getDate()} ${(tempDate.getHours() < 10) ? '0' + tempDate.getHours() : tempDate.getHours()}:${(tempDate.getMinutes() < 10) ? '0' + tempDate.getMinutes() : tempDate.getMinutes()}:${(tempDate.getSeconds() < 10) ? '0' + tempDate.getSeconds() : tempDate.getSeconds()}.000`;
    }
}

class CubaEntityFilterCondition {
}

class CubaEntityFilterConditionORGroup {
    constructor() {
        this.group = 'OR';
    }
}

/**
 * This class represents the 'filter' parameter that shoud be passed to Cuba backend in order to filter entities
 * see https://doc.cuba-platform.com/restapi-7.2/#rest_api_v2_ex_search_filter
 * and https://files.cuba-platform.com/swagger/7.2/#!/Entities/get_entities_entityName_search
 */
class CubaEntityFilter {
}

/**
 * Classe base di INPUT per servizi paginati con lo stesso pattern utilizzato da CUBA.
 */
class BaseCubaPageI {
}

/**
 * Classe base di OUTPUT per servizi paginati con lo stesso pattern utilizzato da CUBA
 */
class BaseCubaPageO {
}

/**
 * This class describes the correct output of a login request, that is jwt
 */
class JwtDTO {
}

class SpringLoginResponse {
    constructor(flag, status = 200, er = '') {
        this.statusCode = status;
        this.error = er;
        this.ok = flag;
    }
}

/**
 * SpringRest service class
 * This service is used to manage HTTP connections to a Spring Backend.
 */
class SpringRestService {
    /**
     * This is the class constructor, which instantiates a private object
     * @param http the HttpClient object used to perform http requests and handle their responses
     */
    constructor(http) {
        this.http = http;
        /**
         * This private property is used to store the login status (Logged / Not Logged)
         */
        this.isUserLogged = false;
        /**
         * URL used for login operations
         */
        this.loginService = '/login';
        /**
         * URL used for refresh operations
         */
        this.refreshService = '/refreshToken';
        /**
         * This EventEmitter is triggered when the token is correctly received from server and stored
         */
        this.tokenCaught = new EventEmitter();
        this.Token = new JwtDTO();
    }
    /**
     * The method encrypts the plain password using the SHA2-512 Hashing function
     * @param plainText the plain password
     */
    hashPassword(plainText) {
        return CryptoJS.SHA512(plainText).toString();
    }
    /**
     * This method is called to check whether the user is correctly logged or not
     */
    isUserLoggedIn() {
        this.isUserLogged = (!!this.Token.access_token) ||
            (localStorage.getItem('access_token') !== undefined && localStorage.getItem('access_token') !== null);
        return this.isUserLogged;
    }
    /**
     * This method is used to execute a http post request in order to gain the access and receive a token
     * @param user: the username
     * @param pswd: the plain password
     * @param urlAPI: the api used to do login
     * @param rememberMe Remember Me flag
     * @param hashPassword flag set to true if the password shall be hashed
     */
    login(user, pswd, urlAPI, rememberMe, hashPassword = true) {
        let encryptedPassword;
        if (hashPassword) {
            encryptedPassword = this.hashPassword(pswd);
        }
        else {
            encryptedPassword = pswd;
        }
        this.urlAPI = urlAPI + this.loginService;
        this.setRefreshUrl(urlAPI);
        return new Observable((observer) => {
            this.http.post(this.urlAPI, { username: user, password: encryptedPassword }, {
                observe: "response",
                headers: new HttpHeaders({
                    Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                })
            }).subscribe((response) => {
                if (response.body !== undefined) {
                    const tokens = response.body;
                    // IF REMEMBER ME, STORE IN LOCAL STORAGE
                    // ELSE, USE JWT Object
                    if (rememberMe) {
                        // activated REMEMBER ME, MUST STORE TOKEN in LOCAL STORAGE
                        this.rememberMeFlag = true;
                        localStorage.setItem('access_token', tokens.access_token);
                        localStorage.setItem('refresh_token', tokens.refresh_token);
                    }
                    else {
                        // deactivated REMEMBER ME, STORE TOKEN ONLY in JWT OBJECT
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('refresh_token');
                        this.rememberMeFlag = false;
                        this.storeTokens(tokens, false);
                    }
                    this.storeTokens(tokens, false);
                    observer.next(new SpringLoginResponse(true));
                }
            }, (error) => {
                if (error instanceof HttpErrorResponse) {
                    observer.error(new SpringLoginResponse(false, error.status, error.error));
                }
                else if (typeof error === 'string') {
                    observer.error(new SpringLoginResponse(false, 200, error));
                }
            });
        });
    }
    /**
     * This method is called when a correct login is done, in order to store the received token and other login information
     * @param tokens login information
     * @param flag is used to check whether the token has been refreshed or not
     */
    storeTokens(tokens, flag) {
        this.Token.access_token = tokens.access_token;
        this.Token.refresh_token = tokens.refresh_token;
        // il servizio non deve utilizzare le rotte, deve essere indipendente --> uso un emettitore di eventi
        if (!flag) {
            this.tokenCaught.emit(tokens.access_token);
        }
    }
    /**
     * This method deletes an access_token saved in internal memory
     */
    clearTokens() {
        // CLEAR TOKEN IN JWT OBJECT
        this.Token.access_token = '';
        this.Token.refresh_token = '';
        this.isUserLogged = false;
        // CLEAR TOKEN IN Local Storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        return true;
    }
    /**
     * This method is called to obtain the string containing the access token
     */
    getToken() {
        const tokenFromStorage = localStorage.getItem('access_token');
        if (!!tokenFromStorage) {
            return tokenFromStorage;
        }
        else {
            return this.Token.access_token;
        }
    }
    /**
     * This method is called to obtain the string containing the refresh token
     */
    getRefreshToken() {
        const tokenRefFromStorage = localStorage.getItem('refresh_token');
        if (!!tokenRefFromStorage) {
            this.rememberMeFlag = true;
            return tokenRefFromStorage;
        }
        else {
            return this.Token.refresh_token;
        }
    }
    /**
     * This method is used to set an AUTH URL to perform refresh token operations
     * @param url the AUTH url
     */
    setAuthUrl(url) {
        this.urlAPI = url;
    }
    /**
     * This method is used to set an AUTH URL to perform refresh token operations
     * @param url the AUTH url
     */
    setRefreshUrl(baseUrl) {
        this.refreshAPI = baseUrl + this.refreshService;
    }
    /**
     * This method is used to set the value for the Accept-Language header
     * @param locale the value of the language
     */
    setLanguage(locale) {
        this.language = locale;
    }
    /**
     * This method is used to get the value for the Accept-Language header
     */
    getLanguage() {
        return this.language;
    }
    /**
     * The method performs the logout from app and calls the clearTokens method
     */
    doLogout() {
        return this.clearTokens();
    }
    /**
     * This method is used to execute a http post request in order to execute a refresh-token operation
     * and receive another valid token
     */
    refreshToken() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
                Authorization: 'Basic Y2xpZW50OnNlY3JldA=='
            })
        };
        return this.http.post(this.refreshAPI, { refresh_token: this.getRefreshToken() }, httpOptions)
            .pipe(tap((tokens) => {
            const tokenRefFromStorage = localStorage.getItem('access_token');
            if (!!tokenRefFromStorage) {
                localStorage.setItem('access_token', tokens.access_token);
                // Non vado a memorizzare il refresh_token perché nullo, eventualmente se scadrà il token si dovrà rifare la login
                // localStorage.setItem('refresh_token', tokens.refresh_token);
                this.rememberMeFlag = true;
            }
            else {
                this.rememberMeFlag = false;
                this.Token.access_token = tokens.access_token;
            }
        }));
    }
    // SERVICES HANDLER
    // a single method that receives the name of the service and the respective cb
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside of the cb if any. If there's a particular error, the message error is generated and passed
     * @param url the API url of the BE
     * @param cb the cb object
     */
    execOPE(url, cb) {
        if (this.refreshAPI === undefined || this.refreshAPI === '') {
            this.setRefreshUrl(url);
        }
        return new Observable((observer) => {
            let cbInput = JSON.parse('{}');
            if (cb !== null) {
                cbInput = JSON.parse(JSON.stringify(cb.i));
            }
            this.http.post(url + '/' + cb.serviceName, {
                i: cbInput
            }).subscribe((resp) => {
                let errorMessage = '';
                // IF OK
                if (resp.r.ec === EXIT_CODE['OK']) {
                    cb.o = JSON.parse(JSON.stringify(resp.o));
                    observer.next(true);
                }
                else {
                    errorMessage = HttpErrorManager.serverErrorHandler(resp.r);
                    observer.error(errorMessage);
                }
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    putEntityImage(url, file, entityId) {
        const map = new Map();
        map.set('entityId', entityId);
        return this.putImage(url, file, map);
    }
    putImage(url, file, params) {
        return new Observable((observer) => {
            const data = new FormData();
            data.append('file', file);
            data.append('mimeType', file.type);
            if (!!params) {
                Array.from(params.keys()).forEach(key => {
                    data.append(key, params.get(key));
                });
            }
            const newRequest = new HttpRequest('POST', url, data, {
                reportProgress: true,
                responseType: 'json'
            });
            this.http.request(newRequest).subscribe((event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    // @ts-ignore
                    // this.progress.percentage = Math.round(100 * event.loaded / event.total);
                }
                else if (event instanceof HttpResponse) {
                    const resp = event.body;
                    let errorMessage = '';
                    // IF OK
                    if (resp.r.ec === EXIT_CODE['OK']) {
                        observer.next(true);
                    }
                    else {
                        errorMessage = HttpErrorManager.serverErrorHandler(resp.r);
                        observer.error(errorMessage);
                    }
                }
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside of the cb if any. If there's a particular error, the message error is generated and passed
     * @param url the API url of the BE
     * @param cb the cb object
     * @param token the tokenOPE
     */
    execOPEWithToken(url, cb, token) {
        const tk = new JwtDTO();
        tk.access_token = token;
        this.storeTokens(tk, false);
        return this.execOPE(url, cb);
    }
    /**
     * The method performs the http call based on the service requested, and processes the output
     * inside of the cb if any. If there's a particular error, the message error is generated and passed
     * @param url the API url of the mock BE
     * @param cb the cb object
     */
    execMockOPE(url, cb) {
        return new Observable((observer) => {
            let cbInput = JSON.parse('{}');
            if (cb !== null) {
                cbInput = JSON.parse(JSON.stringify(cb.i));
            }
            this.http.post(url, {
                cb: {
                    i: cbInput
                }
            }).subscribe((resp) => {
                let errorMessage = '';
                // IF OK
                if (resp.r.ec === EXIT_CODE['OK']) {
                    cb.o = JSON.parse(JSON.stringify(resp.o));
                    observer.next(true);
                }
                else {
                    errorMessage = HttpErrorManager.serverErrorHandler(resp.r);
                    observer.error(errorMessage);
                }
            }, error => {
                observer.error(error);
            });
            return {
                unsubscribe() {
                }
            };
        });
    }
}
SpringRestService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
SpringRestService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; }, propDecorators: { tokenCaught: [{
                type: Output
            }] } });

/**
 * JwtInceptor class.
 * This class is used to intercept http requests and add the access_token generated by the BE in the headers.
 * The class also handles HTTP errors.
 */
class JwtInceptor {
    /**
     * Class constructor
     * @param auth the AuthService object used to perform authentication operations
     * @param router the Router object used to redirect the displayed component (mainly in case of forced logout)
     * @param injector Dependency Injector
     */
    constructor(auth, router, injector) {
        this.auth = auth;
        this.router = router;
        this.injector = injector;
        /**
         * This variable is used to set trace of a refreshing of a Jwt.
         * If true, no more refresh requests should be forwarded to the server
         */
        this.isRefreshing = false;
        /**
         * Variable used to handle token
         */
        this.refreshTokenSubject = new BehaviorSubject(null);
        // Selecting the true service, "EventBusService"
        this.eventBus = injector.get(EventBusService);
    }
    /**
     * The method intercepts the HTTP requests adding the access_token
     * @param request the intercepted request
     * @param next the HttpHandler of the connection
     */
    intercept(request, next) {
        request = this.addToken(request, this.auth.getToken());
        return next.handle(request).pipe(catchError(error => {
            /* SPRING BE HTTP STATUS:
             *  - 200 --> EXIT_CODE OK oppure ERRORE GESTITO
             *  - 401 --> NOT VALID CREDENTIALS, token Expired, refresh token expired
             *  - 403 --> Permission error, forbidden access to specific API
             *  - 400 --> OTHER ERROR client side
             *  - 500 --> ERRORE HTTP (es. timeout)
             */
            if (error instanceof HttpErrorResponse && error.status === 401 && this.auth.getToken()) {
                // Qui andiamo a coprire il caso dei token scaduti
                return this.handle401Error(request, next, error);
            }
            else if (error instanceof HttpErrorResponse && error.status === 401 && !this.auth.getToken()) {
                // ERROR WITH LOGIN (UN-PW wrong)
                return new Observable((observer) => {
                    observer.error(error);
                });
            }
            else if (error instanceof HttpErrorResponse && error.status === 403) {
                // FORBIDDEN
                if (error.error === undefined || error.error.r === undefined) {
                    // Qui andiamo a coprire un qualsiasi errore http
                    return new Observable((observer) => {
                        observer.error(HttpErrorManager.httpErrorHandler(error));
                    });
                }
                else {
                    // Qui andiamo a coprire un qualsiasi errore applicativo non gestito
                    return new Observable((observer) => {
                        observer.error(HttpErrorManager.serverErrorHandler(error.error.r));
                    });
                }
            }
            else if (error.error === undefined || error.error.r === undefined) {
                // Qui andiamo a coprire un qualsiasi errore http
                return new Observable((observer) => {
                    observer.error(HttpErrorManager.httpErrorHandler(error));
                });
            }
            else {
                // Qui andiamo a coprire un qualsiasi errore applicativo non gestito
                return new Observable((observer) => {
                    observer.error(HttpErrorManager.serverErrorHandler(error.error.r));
                });
            }
        }));
    }
    /**
     * This method adds the token in the request header
     * @param request Http Request caught
     * @param token Jwt
     */
    addToken(request, token) {
        // requested image resource or json resource
        // do not include token
        if (request.url.endsWith('.json') || request.url.endsWith('.svg')) {
            return request;
        }
        if (request.body instanceof FormData) {
            // multipart/form-data
            return request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
        }
        if (request.url !== this.auth.urlAPI) {
            console.log('adding to ' + request.url + '...');
            if (this.auth.getLanguage() !== undefined) {
                // HANDLE ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'Accept-Language': this.auth.getLanguage()
                    }
                });
            }
            else {
                // NO ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                });
            }
        }
        else {
            if (this.auth.getLanguage() !== undefined) {
                // HANDLE ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'Accept-Language': this.auth.getLanguage()
                    }
                });
            }
            else {
                // NO ACCEPT LANGUAGE
                return request.clone({
                    setHeaders: {
                        Authorization: 'Basic Y2xpZW50OnNlY3JldA==',
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                });
            }
        }
    }
    /**
     * Method used to handle a token refresh. It must allow only one refresh request, and block the others until a new token is obtained
     * @param request: The http request
     * @param next: the Http handler
     * @param error: the error 500 or 403 received from a previous request which started the refresh process
     */
    handle401Error(request, next, error) {
        if (!this.isRefreshing) {
            console.log('askin\' for refreshedToken...');
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            return this.auth.refreshToken().pipe(switchMap((token) => {
                console.log(token);
                this.isRefreshing = false;
                console.log('new token added to old httpRequest...');
                this.refreshTokenSubject.next(token.access_token);
                return next.handle(this.addToken(request, token.access_token));
            }));
        }
        else {
            // this.isRefreshing = false;
            // this.auth.clearTokens();
            // può essere che qui ci vada una refreshToken quando il refresh è scaduto....
            // in questo caso devo prevedere una login di massa
            if (request.url === this.auth.refreshAPI) {
                // refreshToken gone bad.... do login!
                this.isRefreshing = false;
                this.auth.clearTokens();
                // USING BUS TO INFORM THAT AN
                this.eventBus.emit(new EventData(EventBusContstants.FORCE_LOGOUT, null));
                return new Observable((observer) => {
                    observer.error('Invalid refresh_token, must do new login');
                });
            }
            else {
                // 403 response not for bad RefreshToken
                console.log('token already requested... please be patient...');
                return this.refreshTokenSubject.pipe(filter(token => token != null), take(1), switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt));
                }));
            }
        }
    }
}
JwtInceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: JwtInceptor, deps: [{ token: SpringRestService }, { token: i2.Router }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
JwtInceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: JwtInceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: JwtInceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: SpringRestService }, { type: i2.Router }, { type: i0.Injector }]; } });

class SpringRestModule {
}
SpringRestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SpringRestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: SpringRestModule, imports: [BrowserModule, FormsModule, HttpClientModule] });
SpringRestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestModule, providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInceptor,
            multi: true
        }], imports: [BrowserModule, FormsModule, HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SpringRestModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [BrowserModule, FormsModule, HttpClientModule
                    ],
                    providers: [{
                            provide: HTTP_INTERCEPTORS,
                            useClass: JwtInceptor,
                            multi: true
                        }],
                    exports: []
                }]
        }] });

/**
 * BaseSpringServiceCB Class for AIknow CommunicatorBean concept
 */
class BaseSpringServiceCB extends BaseCB {
    constructor(serviceName) {
        super();
        this.serviceName = serviceName;
    }
}

/**
 * TopicDTO class
 */
class TopicDTO {
    /**
     * Class constructor
     * @param topicName the name of the topic
     */
    constructor(topicName) {
        /**
         * Flag true if subscription is active
         */
        this.activeSubscription = false;
        this.topicName = topicName;
    }
}

/**
 * Full Mqtt subscription class
 */
class FullSubscription {
}
/**
 * Mqtt connection manager class
 * This service is used to manage Mqtt connections.
 */
class MqttManagerService {
    /**
     * Class constructor
     * @param _mqttService ngx-mqtt Mqtt service ref
     * @param injector Dependency Injector
     */
    constructor(_mqttService, injector) {
        this._mqttService = _mqttService;
        this.injector = injector;
        this.keepAliveSeconds = 60;
        this.subscriptionsList = new Array();
        this._topicList = new Array();
        // Selecting the true service, "EventBusService"
        this.eventBus = injector.get(EventBusService);
    }
    // ----------------------------------------------------------------------
    //     METODI STATICI DELLA CLASSE
    // ----------------------------------------------------------------------
    /**
     * This static method checks whether the string in input is a JSON object or not
     * @param str the string to check
     */
    static isJsonString(str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    /**
     * Getter for topicList
     */
    get topicList() {
        return this._topicList;
    }
    /**
     * Mqtt broker connection
     * A single connection to the broker for the entire app, in order to prevent disconnections and multiple connections
     */
    connectToMqttBroker(mqttOptions) {
        this.MQTT_OPTIONS = mqttOptions;
        this.MQTT_OPTIONS.keepalive = this.keepAliveSeconds;
        // New connection only if it isn't connected
        if (this._mqttService.state.getValue() !== MqttConnectionState.CONNECTED) {
            this._mqttService.connect(this.MQTT_OPTIONS);
        }
    }
    /**
     * Change the pre-defined keepAlive period (60 seconds).
     * It's necessary to change the keepAlive BEFORE making the connection!!
     * @param seconds keepAliveTime
     */
    setKeepAliveTime(seconds) {
        this.keepAliveSeconds = seconds;
    }
    /**
     * Disconnect to MQTT Broker
     * @param force force disconnection if true
     */
    disconnect(force) {
        this._mqttService.disconnect(force);
    }
    /**
     * Retrieve the connection state
     */
    getConnectionState() {
        return this._mqttService.state;
    }
    /**
     * Retrieve the id of the connected client
     */
    getClientId() {
        return this._mqttService.clientId;
    }
    /**
     * Susbscribe to single topic and return an observable to it
     * @param topic the topic to subscribe to
     */
    execTopicSubscription(topic) {
        return this._mqttService.observe(topic);
    }
    /**
     * Publish to single topic and return an observable to it
     * @param topic the topic to subscribe to
     * @param message the payload message
     */
    execTopicPublication(topic, message) {
        return this._mqttService.publish(topic, message);
    }
    /**
     * The method adds the input topic string to the topic list
     * @param topic the topic string that has to be inserted in the list
     */
    subscribeToNewTopic(topic) {
        this._topicList.push(new TopicDTO(topic));
    }
    /**
     * The method removes the input topic string from the topic list
     * @param topic the topic string that has to be removed from the list
     */
    unsubscribeFromTopic(topic) {
        this._topicList = this._topicList.filter(t => t.topicName !== topic);
    }
    /**
     * The method clears the topic list
     */
    unsubscribeAndClearAllTopics() {
        this.unsubscribeFromTopics();
        this._topicList = new Array();
    }
    /**
     * The method executes a subscription of all the topics stored in the topic list, after an unsubscription
     */
    execSubscription() {
        // BEFORE SUBSCRIPTION, UNSUBSCRIBE FROM ALL TOPICS
        this.unsubscribeFromTopics();
        // NOW, NEW SUBSCRIPTION
        this.subscribeToTopics();
    }
    /**
     * Unsubscribe from all topics
     */
    cancelSubscription() {
        // UNSUBSCRIBE FROM ALL TOPICS
        this.unsubscribeFromTopics();
    }
    /**
     * Subscribe to all the topics stored
     */
    subscribeToTopics() {
        this._topicList.forEach(topic => {
            console.log(`Subscribing to topic ${topic.topicName}`);
            const subscription = new FullSubscription();
            subscription.topicName = topic.topicName;
            subscription.topicSubscription = this._mqttService.observe(topic.topicName)
                .subscribe((message) => {
                if (MqttManagerService.isJsonString(message.payload.toString())) {
                    this.eventBus.emit(new EventData(topic.topicName, JSON.parse(message.payload.toString())));
                }
                else if (!!message && !!message.payload) {
                    this.eventBus.emit(new EventData(topic.topicName, message.payload.toString()));
                }
                else {
                    this.eventBus.emit(new EventData(topic.topicName, null));
                }
            });
            // store subscription in list of subscriptions
            this.subscriptionsList.push(subscription);
            // set subscription as active
            topic.activeSubscription = true;
        });
    }
    /**
     * Unsubscribe from all active topics
     */
    unsubscribeFromTopics() {
        this.subscriptionsList.forEach(subscription => {
            console.log(`Unsubscribed from topic ${subscription.topicName}`);
            subscription.topicSubscription.unsubscribe();
            if (this._topicList.find(topic => topic.topicName === subscription.topicName) !== undefined) {
                this._topicList.find(topic => topic.topicName === subscription.topicName).activeSubscription = false;
            }
        });
        // clear subscriptions list
        this.subscriptionsList = new Array();
    }
}
MqttManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerService, deps: [{ token: i1.MqttService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
MqttManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.MqttService }, { type: i0.Injector }]; } });

/**
 * Mqtt connection options
 */
const MQTT_SERVICE_OPTIONS = {
    // wait connection until app has the necessary connection params
    connectOnCreate: false
};
/**
 * Mqtt Manager module
 */
class MqttManagerModule {
}
MqttManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MqttManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerModule, imports: [BrowserModule, FormsModule, HttpClientModule, i1.MqttModule] });
MqttManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerModule, imports: [BrowserModule, FormsModule, HttpClientModule, MqttModule.forRoot(MQTT_SERVICE_OPTIONS)] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: MqttManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [BrowserModule, FormsModule, HttpClientModule, MqttModule.forRoot(MQTT_SERVICE_OPTIONS)
                    ],
                    exports: []
                }]
        }] });

/**
 * SignalR Manager Service.
 * This service is used to manage SignalR connections.
 */
class SignalRManagerService {
    /**
     * Service constructor.
     * @param injector Dependency Injector
     */
    constructor(injector) {
        this.injector = injector;
        /**
         * Timeout before a reconnection when SignalR connection broke.
         */
        this.RECONNECTION_PAUSE = 5000;
        /**
         * Connection attempts counter
         */
        // private connectionAttemptsCounter = 0;
        /**
         * Max connection attempts value. After this number of attempts, the SignalR connection is no longer tried
         */
        this.MAX_CONNECTION_ATTEMPTS = 10;
        /**
         * These SignalR options are used to configure the connection
         */
        this.signalRConnectionOptions = {
            // Transport 1 is WebSocket
            transport: 1,
        };
        this.connectionList = new Map();
        this.connectionAttemptsCounterList = new Map();
        this.subscriptions = new Array();
        // Selecting the true service, "EventBusService"
        this.eventBus = injector.get(EventBusService);
    }
    /**
     * The methods builds a SignalR Connection from a SignalRConnectionDTO object containing the connection params.
     * @param connection A SignalRConnectionDTO containing url and hub of SignalR server
     */
    buildSignalRConnection(connection) {
        // Check if the same connection is already active: in this case skip the connection building.
        if (this.connectionList.has(`${connection.signalrServerUrl}/${connection.connectionHub}`)) {
            console.log(`Skipping, connection to ${connection.signalrServerUrl}/${connection.connectionHub} already built.`);
        }
        else {
            this.connectionAttemptsCounterList.set(`${connection.signalrServerUrl}/${connection.connectionHub}`, 0);
            // Create a connection to the ASP.NET Core Web Application, specifying the hub, and push it to a list of connections
            // Logging level set to Critical
            this.connectionList.set(`${connection.signalrServerUrl}/${connection.connectionHub}`, new signalR.HubConnectionBuilder()
                .configureLogging(signalR.LogLevel.None)
                .withUrl(`${connection.signalrServerUrl}/${connection.connectionHub}`, this.signalRConnectionOptions)
                .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000, 60000, 120000, null])
                .build());
        }
    }
    /**
     * The method starts a SignalR Connection from a previously built one,
     * and manages the messages sent through it (in both directions).
     * @param connection the connection that is to be started
     */
    startSignalRConnection(connection) {
        // Check if the connection is built, if it does not exist, skip operation.
        if (!this.connectionList.has(`${connection.signalrServerUrl}/${connection.connectionHub}`)) {
            console.warn(`Skipping, connection to ${connection.signalrServerUrl}/${connection.connectionHub} does not exists.`);
        }
        else {
            // Retrieve connection from list
            const conn = this.connectionList.get(`${connection.signalrServerUrl}/${connection.connectionHub}`);
            // Start connection
            conn.start()
                .then(() => {
                this.connectionAttemptsCounterList.set(`${connection.signalrServerUrl}/${connection.connectionHub}`, 0);
                console.log(`Connection to ${connection.signalrServerUrl}/${connection.connectionHub} Started`);
                // Emit connection status as CONNECTED
                this.eventBus.emit(new EventData(EventBusContstants.SIGNALR_STATUS_CONNECTED, true));
                conn.onreconnected(() => {
                    this.eventBus.emit(new EventData(EventBusContstants.SIGNALR_STATUS_CONNECTED, true));
                    console.warn(`SignalR connection reestablished`);
                });
                conn.onclose(() => {
                    console.log(`SignalR connection closed.`);
                });
                conn.onreconnecting(() => {
                    console.warn(`SignalR connection interrupted, reconnecting`);
                    this.eventBus.emit(new EventData(EventBusContstants.SIGNALR_STATUS_CONNECTED, false));
                });
                // SUBSCRIBING TO EVENT COMING FROM THE HUBS AND GOING TO THE APP (EXT to INT)
                connection.hubSubscribingMethodsList.forEach((method) => {
                    // When receiving event from the SignalR connection, push it to the library Event Bus
                    conn.on(method, (messageContent) => {
                        this.eventBus.emit(new EventData(method, messageContent));
                    });
                });
                // SUBSCRIBING TO EVENT COMING FROM THE APP AND GOING TO THE HUBS (INT to EXT)
                connection.hubEmittingMethodsList.forEach((method) => {
                    // When receiving event from the library event bus, push it to the SignalR connection
                    this.subscriptions.push(this.eventBus.on(method, (messageContent) => {
                        conn.send(method, messageContent).catch(err => {
                            console.error(`SignalR method invocation failed: connection status is ${conn.state}`);
                        });
                    }));
                });
            })
                .catch(err => {
                // Reconnection timer
                // Emit connection status as CONNECTED
                this.eventBus.emit(new EventData(EventBusContstants.SIGNALR_STATUS_CONNECTED, false));
                const actualCounter = this.connectionAttemptsCounterList.get(`${connection.signalrServerUrl}/${connection.connectionHub}`) + 1;
                this.connectionAttemptsCounterList.set(`${connection.signalrServerUrl}/${connection.connectionHub}`, actualCounter);
                this.connectionAttemptsTimer = setTimeout(() => {
                    console.warn(`SignalR ${connection.connectionHub} connection attempt ${actualCounter}/${this.MAX_CONNECTION_ATTEMPTS}...`);
                    this.startSignalRConnection(connection);
                }, this.RECONNECTION_PAUSE);
                if (actualCounter > this.MAX_CONNECTION_ATTEMPTS) {
                    clearTimeout(this.connectionAttemptsTimer);
                    this.connectionAttemptsCounterList.set(`${connection.signalrServerUrl}/${connection.connectionHub}`, 0);
                    console.warn(`SignalR ${connection.connectionHub} connection failed after ${this.MAX_CONNECTION_ATTEMPTS} attempts. To retry refresh application`);
                }
            });
        }
    }
    /**
     * The method stops all SignalR active connections and clears the reconnection timer for each of them.
     */
    stopSignalRConnections() {
        // Stop SignalR connections and clear timeouts
        this.connectionList.forEach((value, key) => {
            value.stop().then(() => {
                console.log(`Stopped ${key} connection`);
            }).catch(err => {
                console.log(`Failed to stop ${key}: ${err}`);
            });
        });
        clearTimeout(this.connectionAttemptsTimer);
        this.connectionList = new Map();
        this.connectionAttemptsCounterList = new Map();
        // Unsubscribe from each subscription
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions = new Array();
    }
}
SignalRManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SignalRManagerService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
SignalRManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SignalRManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SignalRManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/**
 * SignalR Connection class used to store the server URL, the server hub
 * and a list of methods from/to which receive/send notifications and messages
 */
class SignalRConnectionDTO {
    /**
     * Class constructor
     * @param url the server url
     * @param hub the specific server hub
     */
    constructor(url, hub) {
        this.signalrServerUrl = url;
        this.connectionHub = hub;
        this.hubSubscribingMethodsList = new Array();
        this.hubEmittingMethodsList = new Array();
    }
}

/**
 * WebSocketService class
 * This service is used to manage Websockets connections.
 */
class WebSocketService {
    /**
     * Method used to connect to a WS
     * @param httpUrl the WS server url
     */
    connect(httpUrl) {
        // This string replacement is valid for both http and https, as the "secure" version of ws is wss,
        // and if the url starts with https the result of the replacement will start with wss.
        const wsUrl = httpUrl.replace(/^http/, 'ws');
        this.webSocketsUrl = wsUrl;
        if (this.connection$) {
            return this.connection$;
        }
        else {
            this.connection$ = webSocket(wsUrl);
            return this.connection$;
        }
    }
    /**
     * Method used to send a message to a WS server
     * @param data the message payload
     */
    send(data) {
        if (this.connection$ && !this.connection$.hasError) {
            this.connection$.next(data);
        }
        else {
            console.error('Did not send data, open a connection first');
        }
    }
    /**
     * Method used to close the WS connection
     */
    closeConnection() {
        if (this.connection$) {
            this.connection$.complete();
            this.connection$ = null;
        }
    }
    /**
     * Class destructor
     */
    ngOnDestroy() {
        this.closeConnection();
    }
}
WebSocketService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: WebSocketService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
WebSocketService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: WebSocketService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: WebSocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * AWS S3 Connection Service Class.
 * This service manages the connection to an AWS S3 bucket
 */
class AwsS3Service {
    constructor() {
        this.initialized = false;
    }
    /**
     * Service initialization.
     * This operation is required before listing or downloading bucket elements.
     * @param bucket s3 bucket
     * @param region s3 region
     * @param accessKeyId access key id
     * @param secretAccessKey secret access key
     * @param ssl true if connection has to be encrypted, false otherwise
     */
    setConnectionParameters(bucket, region, accessKeyId, secretAccessKey, ssl) {
        this.bucket = bucket;
        this.region = region;
        this.protocol = (ssl) ? 'https' : 'http';
        this.awsCredentials = {
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey
        };
        this.connectionOptions = {
            apiVersion: '2006-03-01',
            credentials: this.awsCredentials,
            endpoint: `${this.protocol}://${this.region}.amazonaws.com`,
            sslEnabled: ssl
        };
        this.s3 = new AWS.S3(this.connectionOptions);
        // The initialization is now completed
        this.initialized = true;
    }
    /**
     * The method returns an observable that can provide the list of the objects in the bucket,
     * under the passed prefix
     * @param prefix the elements location in the bucket
     */
    listObjects(prefix) {
        const connectionParams = {
            Bucket: this.bucket,
            Prefix: prefix,
            Delimiter: '/',
            StartAfter: prefix
        };
        return new Observable((observer) => {
            if (this.initialized) {
                // Listing elements
                this.s3.listObjectsV2(connectionParams, (err, data) => {
                    if (err) {
                        // something wrong, rejecting promise
                        observer.error(err);
                    }
                    else {
                        // ok, resolving promise and passing objects list
                        observer.next(data.Contents);
                    }
                });
            }
            else {
                observer.error('AWS S3 Service not initialized.');
            }
            return {
                unsubscribe() {
                }
            };
        });
    }
    /**
     * The method returns the url for a selected object. The object is passed as a param
     * @param element the object to download
     */
    downloadElement(element) {
        if (this.initialized) {
            return this.s3.getSignedUrl('getObject', {
                Bucket: this.bucket,
                Key: element.Key,
                Expires: 3600
            });
        }
        else {
            return null;
        }
    }
}
AwsS3Service.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: AwsS3Service, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AwsS3Service.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: AwsS3Service, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: AwsS3Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*
 * Public API Surface of aik-angular-sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AwsS3Service, BaseCB, BaseCubaPageI, BaseCubaPageO, BaseCubaServiceCB, BaseEntity, BaseEntityCB, BaseSpringServiceCB, CubaEntityFilter, CubaEntityFilterCondition, CubaEntityFilterConditionORGroup, CubaRestModule, CubaRestService, CubaRestUtils, EventBusContstants, EventBusService, EventData, GraphicUtils, LoginResponse, MqttManagerModule, MqttManagerService, SignalRConnectionDTO, SignalRManagerService, SpringRestModule, SpringRestService, TopicDTO, WebSocketService };
